/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs */



/**
* | output |
* | --- |
* | "Shift a single word forward to the beginning of the next Event" |
*
* @param {Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_move_word_to_next_event = /** @type {((inputs?: Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Move_Word_To_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer un mot vers le debut de l'evenement suivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verschiebe ein einzelnes Wort an den Anfang des nächsten Ereignisses.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta una singola parola in avanti all'inizio del prossimo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместите одно слово вперед, в начало следующего события.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazar una sola palabra hacia adelante hasta el comienzo del siguiente evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将一个词向前移动一个位置，放到下一个事件的开头。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次のイベントの先頭まで単語を1つ進めます")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगले इवेंट की शुरुआत में जाने के लिए एक शब्द आगे खिसकाएँ।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desloque uma única palavra para o início do próximo evento.")
	return /** @type {LocalizedString} */ ("Shift a single word forward to the beginning of the next Event")
});